import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { URL_SERVICIOS } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscripcionesService {
  public _url: string = `${URL_SERVICIOS}subscripciones`;

  constructor(private http: HttpClient) {}
  get(condiciones?: any) {
    return this.http
      .get(this._url, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  getById(id: string) {
    return this.http.get(`${this._url}/byid/${id}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  filtrado(condiciones?: any) {
    return this.http
      .get(`${this._url}/filtrado`, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  insert(obj: any) {
    return this.http.post(this._url, obj).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  update(id: string, obj: any) {
    return this.http.put(`${this._url}/${id}`, obj).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  delete(id: string) {
    return this.http.delete(`${this._url}/${id}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
}
